import { Outlet, ScrollRestoration } from 'react-router-dom';

/**
 * Bütün rotaların kökü — yalnız kaydırma yönetimi (12.10.2026).
 *
 * Uygulamada sayfa geçişinde kaydırmayı sıfırlayan bir şey yoktu: yeni sayfa önceki
 * sayfanın kaydırma konumunda açılıyordu. Önceden fark edilmiyordu çünkü ilan sayfası
 * önce kısa bir bekleme ekranı gösteriyor, tarayıcı da konumu kendiliğinden başa
 * çekiyordu; listeden teklif düğmesi ilanı ÖNCEDEN yükleyince sayfa alttan açıldı.
 *
 * Anahtar YOL (pathname): yeni bir sayfa en üstten açılır, geri dönünce kalınan yere
 * dönülür; aynı sayfada süzgeç/sıralama/sayfa değişince (yalnız sorgu değişir) konum
 * korunur — her süzgeçte en üste zıplamasın.
 */
export function RootLayout() {
  return (
    <>
      <ScrollRestoration getKey={(location) => location.pathname} />
      <Outlet />
    </>
  );
}
